import { Model, Attr } from 'spraypaint';
import { Geometry } from '@turf/turf';
import ApplicationRecord from '../ApplicationRecord';

@Model()
export default class Project extends ApplicationRecord {
  static jsonapiType = 'projects';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
      },
      {
        text: 'Name',
        value: 'name',
      },
      {
        text: 'Created',
        value: 'createdAt',
      },
    ];
  }

  static scopeFactory() {
    return Project.includes([]);
  }

  @Attr() name: string;

  @Attr() geometry: Geometry;

  @Attr() createdAt: string;
}
